module.exports = __webpack_public_path__ + "img/bx-4.d81f8af7.jpg";